<template>
    <v-flex xs12 sm12 d-block class="card-dados">
        <h3 class="card-dados__titulo">Dados da Compra Direta</h3>
        <v-layout wrap align-center white>
            <v-flex xs12 sm3 d-flex>
                <div class="az-text">
                    <label>Nº Compra Direta</label>
                    <p>{{value.numero ? `${value.numero}/${value.ano}` : '--'}}</p>
                </div>
            </v-flex>

            <v-flex xs12 sm3 d-flex>
                <v-select :disabled="deveDeshabilitarAmparoLegal || deveDesabilitarCamposGerais" name="Amparo Legal" label="Amparo Legal" placeholder="Selecione"
                          key="AmparoLegal" :return-object="true"
                          :menu-props="{ top: false, offsetY: true }"
                          v-model="value.amparoLegal" class="required-field" v-validate="'required'"
                          :items="(value.amparosLegais ? value.amparosLegais : []).map(({id, lei}) => ({id, lei}))"
                          item-text="lei" item-value="id" :error-messages="errors.collect('Amparo Legal')"/>
            </v-flex>

            <v-flex xs12 sm3 d-flex>
                <v-select
                          :disabled="deveDesabilitarCamposGerais || (tiposCompraDiretaPermitidos.length === 1 && value.tipo === tiposCompraDiretaPermitidos[0].valor)"
                          name="Tipo"
                          key="Tipo"
                          label="Tipo"
                          placeholder="Selecione"
                          :menu-props="{ top: false, offsetY: true }"
                          v-model="value.tipo"
                          class="required-field"
                          v-validate="'required'"
                          :items="tiposCompraDiretaPermitidos"
                          :error-messages="errors.collect('Tipo')"
                          item-text="texto"
                          item-value="valor"
                />
            </v-flex>

            <v-flex xs12 sm3 d-flex>
                  <v-select :disabled="deveDesabilitarCamposGerais" name="Criterio Julgamento" key="CriterioJulgamento" label="Critério Julgamento" placeholder="Selecione"
                            :menu-props="{ top: false, offsetY: true }"
                            v-model="value.criterioJulgamento" class="required-field" v-validate="'required'"
                            :items="Object.entries(criteriosJulgamento).map(([key, value]) => ({key: value.valor, value: value.texto}))"
                            :error-messages="errors.collect('Criterio Julgamento')" item-text="value" item-value="key"/>
            </v-flex>

            <v-flex xs12 sm3 d-flex>
                <div class="az-text">
                    <label>Data/Hora de Criação</label>
                    <p>{{value.dataHoraAbertura | az-date(humanizarFormatoDataHora(value.dataHoraAbertura))}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div class="az-text">
                    <label>Criado por</label>
                    <p>{{value.criadoPor ? value.criadoPor : '--'}}</p>
                </div>
            </v-flex>

            <v-flex v-if="!ehCompraPropostaManualEhAtiva" xs12 sm3 d-flex>
                <cd-date-time-picker v-model.lazy="value.dataHoraInicioEnvioPropostas"
                                   label="Data/Hora Início Envio de Propostas"
                                   name-date="Data Início Envio de Propostas"
                                   name-hour="Hora Início Envio de Propostas"
                                   :min-date="dataMinimaInicicioEnvioProposta"
                                   :disabled="deveDesabilitarCamposGerais && !deveHabilitarCamposDatasSuspensa"
                                   class="not-required-field"/>
            </v-flex>
            <v-flex xs12 sm3 d-flex v-if="!exibirFimEnvioPropostasELances && !ehCompraPropostaManualEhAtiva">
                <cd-date-time-picker v-model.lazy="value.dataHoraEncerramento"
                                   label="Data/Hora de Encerramento"
                                   name-date="Data de Encerramento"
                                   name-hour="Hora de Encerramento"
                                   :min-date="dataMinimaEncerramento"
                                   :disabled="deveDesabilitarCamposGerais"
                                   is-required class="required-field"/>
            </v-flex>
            <v-flex xs12 sm3 d-flex v-if="exibirFimEnvioPropostasELances && !ehCompraPropostaManualEhAtiva">
                <cd-date-time-picker v-model="value.dataHoraFimEnvioPropostas"
                                   label="Data/Hora Fim Envio de Propostas"
                                   name-date="Data Fim Envio de Propostas"
                                   name-hour="Hora Fim Envio de Propostas"
                                   :min-date="dataMinimaEncerramento"
                                   :disabled="deveDesabilitarCamposGerais && !deveHabilitarCamposDatasSuspensa"
                                   is-required class="required-field"/>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="exibirFimEnvioPropostasELances && value.tipo === 'COM_DISPUTA' && !ehCompraPropostaManualEhAtiva">
                <v-text-field v-model="value.duracaoEtapaLances"
                              label="Duração Etapa de Lances" :placeholder="'Em horas e minutos, Ex: 06:30'"
                              name="Duração Etapa de Lances" type="text" class="required-field"
                              key="Duração-Etapa-de-Lances"
                              :maxlength="5"
                              :disabled="deveDesabilitarCamposGerais"
                              v-mask="['##:##']"
                              v-validate="`required|tempo_etapa_lance:${tempoMinimoEtapaLance},${tempoMaximoEtapaLance}`"
                              :error-messages="errors.collect('Duração Etapa de Lances')"/>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="deveMostrarTempoRandomico && !ehCompraPropostaManualEhAtiva">
                <div class="az-text">
                    <label>Tempo Randômico</label>
                    <p>De 1 a {{tempoRandomicoLance ? tempoRandomicoLance : '--'}} minutos</p>
                </div>
            </v-flex>

            <v-flex xs12 sm3 d-flex>
                <v-text-field label="Contato" name="Contato" placeholder="Contato" class="required-field"
                              key="Contato"
                              :disabled="deveDesabilitarCamposGerais"
                              :error-messages="errors.collect('Contato')" maxlength="100"
                              v-model="value.nomeContato" v-validate="'required'" :counter="100"/>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <v-text-field label="Telefone" name="Telefone" class="required-field"
                              key="Telefone"
                              :disabled="deveDesabilitarCamposGerais"
                              :error-messages="errors.collect('Telefone')" placeholder="(00) 0000-0000"
                              v-mask="['(##) #####-####','(##) ####-####']"
                              v-model="value.telefoneContato" v-validate="'required'"/>
            </v-flex>

            <v-flex xs12 sm3 d-flex>
              <v-textarea
                  filled
                  name="Prazo de Entrega"
                  key="Prazo-de-Entrega"
                  label="Prazo de Entrega"
                  placeholder="Ex. 30 dias"
                  rows="1"
                  maxlength="1000"
                  :counter="1000"
                  :disabled="deveDesabilitarCamposGerais"
                  :error-messages="errors.collect('Prazo de Entrega')" type="text"
                  v-model="value.prazoEntregaDescritivo" v-validate="'required' " class="required-field"/>
            </v-flex>

            <v-flex xs12 sm3 d-flex>
                <v-text-field label="Local de Entrega" name="Local de Entrega" class="required-field"
                              key="Local-de-Entrega"
                              :disabled="deveDesabilitarCamposGerais"
                              placeholder="Ex. no próprio órgão" :error-messages="errors.collect('Local de Entrega')"
                              v-model="value.localEntrega" v-validate="'required'" maxlength="500" :counter="500"/>
            </v-flex>
            <v-flex v-if="ehLei14_133(value.amparoLegal) || ehLei13_303(value.amparoLegal)" xs12 sm3 d-flex>
              <div class="az-checkbox">
                <div class="checkbox-label">
                  Dispensa sem Valor Estimado
                  <span style="color: #FF6262">*</span>
                </div>
                <v-radio-group row name="Dispensa sem Valor Estimado"
                               key="Dispensa-sem-Valor-Estimado"
                               v-model="value.possuiValorReferencia"
                               :disabled="deveDesabilitarCamposGerais"
                               v-validate="'required'"
                               :error-messages="errors.collect('Dispensa sem Valor Estimado')">
                  <v-radio label="Sim" :value="false"/>
                  <v-radio label="Não" :value="true"/>
                </v-radio-group>
              </div>
            </v-flex>
            <v-flex v-if="!(ehLei14_133(value.amparoLegal) || ehLei13_303(value.amparoLegal)) || value.possuiValorReferencia" xs12 sm3 d-flex>
                <div class="az-checkbox">
                    <div class="checkbox-label">
                        Exibir Valor de Referência
                    </div>
                    <v-radio-group row name="Exibir Valor de Referência"
                                   key="Exibir-Valor-de-Referência"
                                   v-model="value.exibeValorReferencia"
                                   :disabled="deveDesabilitarCamposGerais"
                                   v-validate="'required'"
                                   :error-messages="errors.collect('Exibir Valor de Referência')">
                        <v-radio label="Sim" :value="true"/>
                        <v-radio label="Não" :value="false"/>
                    </v-radio-group>
                </div>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="value.tipo === 'COM_DISPUTA'">
                <v-select name="Disputa por" label="Disputa por" placeholder="Selecione" key="Disputa-por"
                          v-model="value.disputaPor" class="required-field" v-validate="{ required: value.tipo === 'COM_DISPUTA' }"
                          :disabled="deveDesabilitarCamposGerais"
                          :items="Object.entries(disputarPorValido).map(([key, value]) => ({key:value.valor, value:value.texto}))"
                          item-text="value" item-value="key" :error-messages="errors.collect('Disputa por')"/>
            </v-flex>

            <v-flex xs12 sm3 d-flex>
                <div class="az-text">
                    <label>Situação</label>
                    <p v-if="value.situacao">{{value.situacao | azEnum(situacoesCompraDireta)}}</p>
                    <p v-else> -- </p>
                </div>
            </v-flex>

            <v-flex xs12 sm9>
                <v-textarea name="Observação" label="Observação" v-model="value.observacao" rows="1"
                            key="Observação" :auto-grow="countObservacaoRows < 15"  max-rows="16"
                            :disabled="deveDesabilitarCamposGerais"
                            placeholder="Ex. Compra de Material de Expediente"/>
            </v-flex>
        </v-layout>
        <v-layout wrap align-center white>
            <v-flex xs12 sm3 d-flex>
                <div class="az-checkbox">
                    <div class="checkbox-label">
                        Recurso Federal
                    </div>
                    <v-radio-group row name="Recurso Federal"
                                   key="Recurso-Federal"
                                   v-model="value.recursoFederal"
                                   :disabled="deveDesabilitarCamposGerais"
                                   v-validate="'required'"
                                   :error-messages="errors.collect('Recurso Federal')">
                        <v-radio label="Sim" :value="true"/>
                        <v-radio label="Não" :value="false"/>
                    </v-radio-group>
                </div>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="value.recursoFederal">
                <v-select name="Tipo Transferência" label="Tipo Transferência" placeholder="Selecione"
                          key="Tipo-Transferência"
                          :menu-props="{ top: false, offsetY: true }"
                          v-model="value.tipoTransferencia" class="required-field" v-validate="'required'"
                          :disabled="deveDesabilitarCamposGerais"
                          :items="Object.entries(tiposTransferencia).map(([key, value]) => ({key, value}))"
                          item-text="value" item-value="key" :error-messages="errors.collect('Tipo Transferência')"/>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios">
                <v-text-field label="Nº Convênio" name="Nº Convênio" class="required-field" type="number"
                              key="Nº-Convênio"
                              :disabled="deveDesabilitarCamposGerais"
                              placeholder="Ex. 012021" :error-messages="errors.collect('Nº Convênio')"
                              v-model="value.numeroConvenio" v-validate="'required|length:6|integer'" maxlength="6" :counter="6"/>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios">
                <v-menu id="menuAnoInstrumento" ref="menuAnoInstrumento" :close-on-content-click="false"
                        v-model="menuAnoInstrumento" lazy
                        :nudge-top="posicaoVerticalMenuSelecaoDeAnoInstrumento()"
                        transition="scale-transition" offset-y full-width min-width="200px">
                    <v-text-field label="Ano Instrumento" name="Ano Instrumento" key="Ano-Instrumento" type="number"
                                  slot="activator" append-icon="event"
                                  v-model="value.anoInstrumento" placeholder="Ex. 01" class="mr-2 required-field"
                                  :disabled="deveDesabilitarCamposGerais"
                                  v-validate="'required|max:4|integer|min_value:1'"
                                  :error-messages="errors.collect('Ano Instrumento')"/>

                    <v-date-picker ref="anoInstrumentoPicker" v-model="anoInstrumento"
                                   @input="selecionarAnoInstrumento" reactive no-title
                                   :max="anoMaximoPermitido+'/12'" :min="anoMinimoPermitido"/>
                </v-menu>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios">
                <v-select name="Legislação" label="Legislação" placeholder="Selecione"
                          key="Legislação"
                          :menu-props="{ top: false, offsetY: true }"
                          v-model="value.legislacao" class="required-field" v-validate="'required'"
                          :disabled="deveDesabilitarCamposGerais"
                          :items="value.legislacoes.map(({id, codigo, codigoIntegracao}) => ({key:codigoIntegracao, value:codigo}))"
                          item-text="value" item-value="key" :error-messages="errors.collect('Legislação')"/>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios">
                <v-select name="Tipo Objeto" label="Tipo Objeto" placeholder="Selecione"
                          key="Tipo Objeto"
                          :menu-props="{ top: false, offsetY: true }"
                          v-model="value.tipoObjeto" class="required-field" v-validate="'required'"
                          :disabled="deveDesabilitarCamposGerais"
                          :items="Object.entries(tiposObjeto).map(([key, value]) => ({key, value}))"
                          item-text="value" item-value="key" :error-messages="errors.collect('Tipo Objeto')"/>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios">
                <v-select name="Origem Recurso" label="Origem Recurso" placeholder="Selecione"
                          key="Origem Recurso"
                          :menu-props="{ top: false, offsetY: true }"
                          v-model="value.origemRecurso" class="required-field" v-validate="'required'"
                          :disabled="deveDesabilitarCamposGerais"
                          :items="Object.entries(origensRecursoFederal).map(([key, value]) => ({key, value}))"
                          item-text="value" item-value="key" :error-messages="errors.collect('Origem Recurso')"/>
            </v-flex>
        </v-layout>
        <v-layout wrap align-center white v-if="deveMostrarIntervaloDeLances">
            <v-flex xs12 sm3 d-flex ma-0>
              <v-text-field v-model="value.intervaloLances"
                            label="Diferença Mínima entre Lances" :placeholder="'Exemplo: 0.0001'"
                            name="Intervalo de Lances" type="tel" :class="validarObrigatoriedadeDiferencaMinimaEntreLances ? 'required-field' : ''"
                            key="Intervalo-Lances"
                            :maxLength="2+value.casasDecimais"
                            :disabled="deveDesabilitarCamposGerais"
                            v-validate="validarObrigatoriedadeDiferencaMinimaEntreLances ? 'required|min_value:0.0001' : 'min_value:0.0001'"
                            :error-messages="errors.collect('Intervalo de Lances')"/>
            </v-flex>
            <v-flex xs12 sm2 d-flex class="px-0 campo-tipo-validacao">
              <v-select name="Tipo de Validação" key="Tipo-de-Validação" placeholder="Selecione"
                        :menu-props="{ top: false, offsetY: true }"
                        v-model="value.validarIntervaloLancesPor" class="required-field" v-validate="'required'"
                        :disabled="deveDesabilitarCamposGerais"
                        :items="validarIntervaloLancesPor"
                        :error-messages="errors.collect('Tipo de Validação')" item-text="value" item-value="key"/>
            </v-flex>

        </v-layout>
    </v-flex>
</template>

<script>
import {disputasCompraDireta, situacoesCompraDireta,
    tiposCompraDireta, criteriosReducaoCasasDecimais, tiposTransferencia,
    tiposObjeto, origensRecursoFederal, criteriosJulgamento, validacaoIntervaloLances} from '@/core/constants'
import CdDateTimePicker from '@/views/pages/commons/painel/painel-compra-direta/CdDateTimePicker'
import {mapState} from 'vuex'
import dateMixin from '@/views/mixins/date'
import amparoLegalUtilsMixin from '@/views/mixins/amparoLegalUtils'
import exibirFimPropostaMixin from '@/views/mixins/exibirFimProposta'

export default {
    name: 'PainelCompraDiretaEdicao',
    components:{CdDateTimePicker},
    mixins: [dateMixin, amparoLegalUtilsMixin, exibirFimPropostaMixin],
    inject: ['$validator'],
    props: {
        value: {
            required: true
        },
        tempoRandomicoLance:{
            type: Number,
            default: null
        },
        lei14133UsaTempoRandomicoLance: {
            type: Boolean,
            default: false
        },
        lei13303UsaTempoRandomicoLance: {
            type: Boolean,
            default: false
        },
        intervaloDuracaoLancesLei8666:{
            type: Object,
            default: null
        },
        intervaloDuracaoLancesLei14133:{
            type: Object,
            default: null
        },
        intervaloDuracaoLancesLei13303:{
            type: Object,
            default: null
        },
        ehCompraPropostaManualEhAtiva: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            menu: false,
            anoCompraDireta: null,
            menuAnoInstrumento: false,
            anoInstrumento: null,
            disputasCompraDireta,
            situacoesCompraDireta,
            tiposCompraDireta,
            criteriosReducaoCasasDecimais,
            tiposTransferencia,
            tiposObjeto,
            origensRecursoFederal,
            criteriosJulgamento,
            validacaoIntervaloLances
        }
    },
    computed: {
        ...mapState(['parametros']),
        transferenciaVoluntarios(){
            return this.value.tipoTransferencia === 'VOLUNTARIAS'
        },
        dataMinimaEncerramento(){
            return this.moment(new Date(Date.now())).subtract(1, 'days').format('YYYY-MM-DDTHH:mm:ss')
        },
        dataMinimaInicicioEnvioProposta(){
            return this.moment(new Date(Date.now())).format('YYYY-MM-DD')
        },
        anoMaximoPermitido(){
            const data = new Date()
            data.setFullYear(data.getFullYear() + 1)
            return `${data.getFullYear()}`
        },
        anoMinimoPermitido(){
            const data = new Date()
            data.setFullYear(data.getFullYear() - 1)
            return `${data.getFullYear()}`
        },
        tempoMinimoEtapaLance()
        {
            if(this.ehLei14_133(this.value.amparoLegal))
                return this.intervaloDuracaoLancesLei14133.min
            if(this.ehLei13_303(this.value.amparoLegal))
                return this.intervaloDuracaoLancesLei13303.min

            return this.intervaloDuracaoLancesLei8666.min
        },
        tempoMaximoEtapaLance()
        {
            if(this.ehLei14_133(this.value.amparoLegal))
                return this.intervaloDuracaoLancesLei14133.max
            if(this.ehLei13_303(this.value.amparoLegal))
                return this.intervaloDuracaoLancesLei13303.max

            return this.intervaloDuracaoLancesLei8666.max
        },
        exibirFimEnvioPropostasELances() {
            return this.exibirFimPropostasELances(this.value.amparoLegal)
        },
        deveMostrarIntervaloDeLances() {
            return (this.ehLei14_133(this.value.amparoLegal) || this.ehLei13_303(this.value.amparoLegal)) && (this.value.tipo && this.value.tipo === 'COM_DISPUTA')
        },
        deveMostrarTempoRandomico() {
            return (this.value.tipo && this.value.tipo === 'COM_DISPUTA') &&
                ((this.ehLei14_133(this.value.amparoLegal) && this.lei14133UsaTempoRandomicoLance) ||
                    (this.ehLei13_303(this.value.amparoLegal) && this.lei13303UsaTempoRandomicoLance))
        },
        validarIntervaloLancesPor() {
            if(!this.value.validarIntervaloLancesPor)
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.value.validarIntervaloLancesPor = 'VALOR'

            return Object.values(validacaoIntervaloLances).map((value) => ({key: value.valor, value: value.texto}))
        },
        disputarPorValido(){
            if(this.value.tipo === 'COM_DISPUTA' && this.value.criterioJulgamento === 'MAIOR_DESCONTO'){
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.value.disputaPor = this.disputasCompraDireta.UNITARIO.valor
                return {
                    UNITARIO: {texto: this.disputasCompraDireta.UNITARIO.texto, valor: this.disputasCompraDireta.UNITARIO.valor}
                }
            }
            return this.disputasCompraDireta
        },
        countObservacaoRows(){
            if(!this.value.observacao) return 0
            return (this.value.observacao.match(/[\r\n|\r|\n]/g) || []).length
        },
        deveDeshabilitarAmparoLegal(){
            return this.value.ehAmparoLegalImportado
        },
        validarObrigatoriedadeDiferencaMinimaEntreLances(){
            return (this.parametros.propriedadesCompraDiretas.exigirDiferencaMinimaEntreLances || this.value.recursoFederal)
        },
        tipoDisputaPermitido(){
            return this.parametros.propriedadesCompraDiretas.tipoDisputaPermitido
        },
        tiposCompraDiretaPermitidos(){
            if (this.ehCompraPropostaManualEhAtiva) {
                return [this.tiposCompraDireta.SEM_DISPUTA]
            }
            if(this.tipoDisputaPermitido === this.tiposCompraDireta.SEM_DISPUTA.valor)
                return [this.tiposCompraDireta.SEM_DISPUTA]
            else if(this.tipoDisputaPermitido === this.tiposCompraDireta.COM_DISPUTA.valor)
                return [this.tiposCompraDireta.COM_DISPUTA]

            return Object.values(this.tiposCompraDireta)
        },
        deveHabilitarCamposDatasSuspensa(){
            return this.value.situacao === 'SUSPENSA'
        },
        deveDesabilitarCamposGerais(){
            return this.value.situacao === 'SUSPENSA'
        }
    },
    watch: {
        menu(val) {
            this.anoCompraDireta = String(this.value.ano)
            val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
        },
        menuAnoInstrumento(val) {
            this.anoInstrumento = String(this.value.anoInstrumento)
            val && this.$nextTick(() => (this.$refs.anoInstrumentoPicker.activePicker = 'YEAR'))
        },
        tiposCompraDiretaPermitidos: {
            handler(val) {
                if (Array.isArray(val) && val.length === 1 && (this.value.tipo == null || this.value.tipo !== val[0].valor) ) {
                    this.value.tipo = val[0].valor
                }
            },
            immediate: true
        },
        'value.recursoFederal'(val){
            if(val===false){
                this.value.tipoTransferencia = null
            }
            if(val===true && !this.value.anoInstrumento){
                this.value.anoInstrumento = new Date().getFullYear()
            }
        },
        'value.tipo'(val){
            const lista = this.tiposCompraDiretaPermitidos
            const temUmTipo = Array.isArray(lista) && lista.length === 1
            if ((val == null || val === '') && temUmTipo) {
                this.$nextTick(() => {
                    this.value.tipo = lista[0].valor
                })
            }
        },
        'value.amparoLegal.prazo': function () { this.aplicarPrazoAutomatico() },
        'value.dataHoraInicioEnvioPropostas': function () { this.aplicarPrazoAutomatico() },
        exibirFimEnvioPropostasELances: function () { this.aplicarPrazoAutomatico() }
    },
    mounted() { this.aplicarPrazoAutomatico() },
    methods: {
        selecionarAnoInstrumento(date) {
            let anoFormatado = date.substring(0, 4)
            let dataAtual = new Date()
            dataAtual.setFullYear(anoFormatado)
            this.value.anoInstrumento = String(dataAtual.getFullYear())
            this.$refs.menuAnoInstrumento.save(this.value.anoInstrumento)
            this.$refs.anoInstrumentoPicker.activePicker = 'YEAR'
            this.menuAnoInstrumento = false
        },
        posicaoVerticalMenuSelecaoDeAnoInstrumento(){
            let posicao = 20
            if(this.errors.collect('Ano Instrumento').length > 0) {
                posicao = 60
            }
            return posicao
        },
        adicionarDiasUteis(base, diasUteis){
            if(!base) return null
            const isWeekday = m => m.day() !== 0 && m.day() !== 6
            let m = this.moment(base)
            if(!m.isValid()) return null
            let adicionados = 0
            while(adicionados < Number(diasUteis || 0)){
                m = m.add(1, 'day')
                if(isWeekday(m)) adicionados++
            }
            return m.format('YYYY-MM-DDTHH:mm:ss')
        },
        aplicarPrazoAutomatico(){
            const amparo = this.value && this.value.amparoLegal
            if(!amparo || amparo.prazo == null) return
            if(this.ehCompraPropostaManualEhAtiva) return
            const exibirFim = this.exibirFimEnvioPropostasELances
            const inicio = this.value.dataHoraInicioEnvioPropostas
            const agora = new Date()
            const base = inicio || agora
            if(exibirFim && !this.value.dataHoraFimEnvioPropostas){
                this.value.dataHoraFimEnvioPropostas = this.adicionarDiasUteis(base, amparo.prazo)
            }
            if(!exibirFim && !this.value.dataHoraEncerramento){
                this.value.dataHoraEncerramento = this.adicionarDiasUteis(base, amparo.prazo)
            }
        }
    }
}
</script>

<style lang="stylus">
    .campo-ano
        max-width 100px

    .v-date-picker-years
        height auto

    .campo-tipo-validacao
        max-width 120px !important
</style>